export default __webpack_public_path__ + "static/media/blue-ball-inverted.9052852d.svg";